<template>
  <section>
    <form @submit.prevent="loadData">
      <div class="section_search">
        <div class="tray">
          <div class="row">
            <div class="cell">
              <select v-model="formData.type">
                <option value="PAGEVIEW">사용건수 보기</option>
                <option value="USERVIEW">사용자수 보기</option>
              </select>

              <select v-model="formData.range">
                <option value="WEEKLY">주간</option>
                <option value="MONTHLY">월간</option>
                <option value="QUARTERLY">분기</option>
                <option value="YEARLY">년간</option>
              </select>

              <WeekPicker
                v-if="formData.range === 'WEEKLY'"
                class="blank"
                width="300px"
                ref="picker"
                :value="$utils.calcDate(new Date(), '-1w')"
                :maxDate="new Date()"
              />
              <MonthPicker
                v-if="formData.range === 'MONTHLY'"
                class="blank"
                ref="picker"
                :maxDate="new Date()"
              />
              <QuarterPicker
                v-if="formData.range === 'QUARTERLY'"
                class="blank"
                ref="picker"
                :maxDate="new Date()"
              />
              <YearPicker
                v-if="formData.range === 'YEARLY'"
                class="blank"
                ref="picker"
                minDate="2017"
                :maxDate="new Date()"
              />
            </div>
            <span class="label">지역</span>
            <div class="cell">
              <GroupSelector permissionCode="statistic" :useGroup="false" ref="groupSelector" />
              <button type="submit" class="btn_search">검색</button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- //search -->

    <StatTotal :statData="statData" :excelFileName="$utils.excelName('전체통계', 'Daily')" />
  </section>
</template>

<script>
import StatTotal from "./components/StatTotal";

export default {
  components: { StatTotal },
  data() {
    return {
      statData: null,
      formData: {
        type: "PAGEVIEW",
        range: "WEEKLY",
        searchDateFrom: "",
        searchDateTo: "",
        state: "",
        city: ""
      }
    };
  },
  methods: {
    requestOptions() {
      const group = this.$refs.groupSelector.getData();
      const { startDate, endDate } = this.$refs.picker.getData();
      return {
        params: _.merge(this.formData, {
          searchDateFrom: this.$utils.dateText(startDate),
          searchDateTo: this.$utils.dateText(endDate),
          orgCode: group.orgId,
          state: group.stateId,
          city: group.cityId
        })
      };
    },
    loadData() {
      this.$axios
        .get("/admin/happy/stats/v2/daily", this.requestOptions())
        .then(({ data }) => (this.statData = data.allStatDataList));
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>
